import styled from 'styled-components';
import { tablet768 } from '@nubank/nuds-web/styles/breakpoints';

import Block from 'components/structure/Block/Block';
import { paddingBuilder } from 'styles/themeUtils';

const ListBlock = styled(Block)`
  ${paddingBuilder.all(0)}

  ${tablet768`
    ${paddingBuilder.all(0)}
  `}
`;

ListBlock.displayName = 'ListBlock';

export default ListBlock;
